import { lazy } from 'react';

// Lazy load state pages to reduce initial bundle size
export const Queensland = lazy(() => import("@/pages/states/Queensland"));
export const SouthAustralia = lazy(() => import("@/pages/states/SouthAustralia"));
export const WesternAustralia = lazy(() => import("@/pages/states/WesternAustralia"));
export const Tasmania = lazy(() => import("@/pages/states/Tasmania"));
export const NorthernTerritory = lazy(() => import("@/pages/states/NorthernTerritory"));
export const ACT = lazy(() => import("@/pages/states/ACT"));
export const Victoria = lazy(() => import("@/pages/states/Victoria"));
export const NewSouthWales = lazy(() => import("@/pages/states/NewSouthWales"));
